import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/fornecedor' };
/////////////////////////////////////////////////////////////////////////////////

export function createFornecedorCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateFornecedorCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listFornecedorCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findFornecedorCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllFornecedorCadastro() {
  return httpService.get({ ...args, path: '/fornecedor/all' });
}

export function deleteFornecedorCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

export function findCnpj(cnpj) {
  return httpService.get({ ...args, args: `/find/dataByCnpj/${cnpj}` });
}

export function findCep(cep) {
  return httpService.get({ ...args, args: `/find/addressByCep/${cep}` });
}

export function filterFornecedorCadastro(idPropriedade, where) {
  return httpService.get({ ...args, args: `?propriedade=${idPropriedade}${where}` });
}